<template>
    <div>
        <v-toolbar card dark color="primary" class="cabecalho">
            <v-btn class="botao-voltar text-uppercase" @click="$emit('voltar')" flat depressed>
                <v-icon>arrow_left</v-icon>
                <span class="texto">Voltar</span>
            </v-btn>

            <div class="cabecalho__texto">
                <div class="cabecalho__info">
                    <p>
                        <strong>Nº Contratação</strong><br>
                        {{ value.numero }}
                    </p>
                    <p>
                        <strong>{{ 'Fornecedor' }}</strong><br>
                        {{ value.razaoSocial }}
                    </p>
                    <p>
                      <strong>Órgão</strong><br>
                      <span>
                             {{ value.siglaUnidadeOrganizacional }}
                      </span>
                    </p>
                    <p>
                        <strong>Situação</strong><br>
                        <span>
                           {{ value.situacao }}
                        </span>

                    </p>
                </div>

                <div class="cabecalho-mobile__titulo">
                    <p>Credenciamento</p>
                </div>

                <button class="cabecalho-mobile__botao" @click="exibirInformacoes">
                    <i class="fas fa-file" aria-hidden="true"/>
                </button>

              <div class="cabecalho__direita" v-if="isMostrarBotoesDeAcoes">
                <v-btn
                    :outline="true"
                    class="text-uppercase"
                    v-text="'APROVAR'"
                    @click="aprovar()"
                    :disabled="!deveMostarBotaoAprovar"
                />
              </div>

            </div>
        </v-toolbar>

        <div v-if="exibirInformacoesMobile" class="cabecalho-mobile__info">
            <p>
                <strong>Nº Processo</strong>
                {{ value.numeroProcesso ? value.numeroProcesso : '--' }}
            </p>
            <p>
                <strong>{{ 'Participante' }}</strong>
                {{ value.fornecedor ? value.fornecedor : '--' }}
            </p>
        </div>
    </div>
</template>

<script>

import situacaoSolicitacaoCredenciamento from '@/commons/constants/situacaoSolicitacaoCredenciamento'
import {actionTypes} from "@/commons/constants";
import AcaoNaoCredenciarSolicitacaoCredenciamento
  from '@/views/credenciamento/detalhe-credenciamento/analise-documentacao-credenciamento/cabecalho/AcaoNaoCredenciarSolicitacaoCredenciamento.vue'

export default {
  name: 'AnaliseDemandaCabecalhoCredenciamentoFornecedor',
  components: {AcaoNaoCredenciarSolicitacaoCredenciamento},
  computed: {
    isMostrarBotoesDeAcoes(){
      return this.editando && this.value.situacao === 'Aguardando aprovação'
    },
    deveMostarBotaoAprovar(){
      return this.value.situacao === 'Aguardando aprovação'
    }
  },
    props: {
        value: {
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            editando: false,
            exibirInformacoesMobile: false,
            situacaoSolicitacaoCredenciamento: situacaoSolicitacaoCredenciamento
        }
    },

    mounted() {
        this.editando = this.$route.query ? this.$route.query.edicao : false
    },

  methods: {
        exibirInformacoes() {
            this.exibirInformacoesMobile = !this.exibirInformacoesMobile
    },
    async aprovar() {
      try {
        this.habilitarLoadingGlobal()

        const payloadParaBackend = {
          situacao: "APROVADA"
        };

        const dadosParaAction = {
          demandaId: this.value.id,
          dados: payloadParaBackend
        };

        const resposta = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.EDITAR_CANCELAR_DEMANDA, dadosParaAction);

        if (resposta && resposta.situacao === 'APROVADA') {
          this.value.situacao = 'Aprovada';
        }

        this.mostrarNotificacaoSucessoDefault()
        this.desabilitarLoadingGlobal()
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    }
    }
}
</script>

<style scoped lang="stylus">
    .botao-voltar
        margin 0 !important
        width 120px
        background-color var(--v-primary-base)
        border-right 1px solid rgba(255, 2555, 2555, .5)
        font-size 12px
        color #fff !important

        .texto
            color #fff !important


    .cabecalho
        position fixed
        z-index 999
        box-shadow 0 2px 4px -1px rgba(0, 0, 0, .4)

        &__direita
          display: flex
          flex: 1
          justify-content: flex-end
          align-items: center

        &__texto
            justify-content space-between
            width 93%
            align-items center
            font-size 12px

            p
                margin 0 20px
                line-height 13px

        &__info, &__texto
            display flex

        &-mobile
            &__botao
                display none
                height 48px
                width 50px
                font-size 16px
                background-color var(--v-primary-darken1)

                &:hover, &:active, &:focus
                    background-color var(--v-primary-darken2)
                    outline 0

            &__info
                padding 54px 0 0
                margin 0
                font-size 13px
                color #777
                display none
                -webkit-transition all 1s cubic-bezier(0, 1, .5, 1)
                -moz-transition all 1s cubic-bezier(0, 1, .5, 1)
                -ms-transition all 1s cubic-bezier(0, 1, .5, 1)
                transition all 1s cubic-bezier(0, 1, .5, 1)
                z-index 2
                position fixed
                background-color #fff
                width 100%
                box-shadow 0 2px 4px -1px rgba(0, 0, 0, .4)

                p
                    margin-bottom 0
                    border-style solid
                    border-width 0 1px 1px
                    border-color #ebebeb
                    padding 10px
                    display flex
                    justify-content space-between
                    text-align right

                strong
                    margin-right 10px

            &__titulo
                font-size 14px
                font-weight 600
                display none
                margin 0 auto
                text-transform uppercase

    @media(max-width 1430px)
        .cabecalho__texto
            width 100%
            flex-wrap wrap

    @media(max-width 1200px)
        .cabecalho__texto p
            margin 0 10px

        .botao-voltar
            padding 0
            margin 0 !important
            flex 0

        .cabecalho__texto, .botao-voltar
            font-size 11px

    @media(max-width 500px)
        .cabecalho
            &__info, .botao-voltar .texto
                display none

            &-mobile__botao, &-mobile__info, &-mobile__titulo
                display block

            .botao-voltar
                font-size 16px
                border-right 0
                min-width 60px

            &-mobile__botao
                height 56px
</style>
